import api from '../../utils/api';

export const createBrand = async (payload) => api.post('/brands', payload);

export const getBrands = async () => api.get('/brands');

export const getBrand = async (id) => api.get(`/brands/${id}`);
